/*
* Thème: STACK
*/

window.FixedContent_PluginInit = function() {
	$('.fixed-content').each(function() {
		$(this).FixedContent()
	})
}

/* End: STACK */

/*
* Thème: PERFORMANCE
*/

window.FixedContent_PluginInit = function() {
	$('.--builder-fixed-content').each(function() {
		$(this).wrapInner('<div class="fixed-content-wrapper"><div class="fixed-content"></div>');
	})

	$('.fixed-content').each(function() {
		$(this).FixedContent()
	})
}

/* End: PERFORMANCE */
